module.exports = __webpack_public_path__ + "img/sustainabilityGold.251d8e0.jpg";